import { Severity, IconErrorColor } from '../constants';

const TreeNodeSelectedColor = '#EAE8E6';

export const getTreeNodeStyles = (_components, { palette }) => {
  const SidebarBorder = `1px solid ${palette.neutralQuaternaryAlt}`;

  return {
    TreeNode: ({ isSelected }) => ({
      width: 240,
      height: '100%',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      borderRight: SidebarBorder,
      padding: 0,
      ...isSelected && {
        backgroundColor: TreeNodeSelectedColor,
      },
    }),
    TreeNodeIcon: {
      width: 40,
      minWidth: 40,
    },
    TreeNodeGlyphicon: {
      margin: '10px 12px 10px 12px !important',
      fontSize: '16px !important',
      top: '0px !important',
    },
    [`TreeNodeGlyphicon-${Severity.AllCampaigns}`]: {
      color: palette.neutralPrimary,
    },
    [`TreeNodeGlyphicon-${Severity.Error}`]: {
      color: IconErrorColor,
    },
    [`TreeNodeGlyphicon-${Severity.Warning}`]: {
      color: palette.orange,
    },
    TreeNodeLeftPadding: ({ isSelected }) => ({
      width: 4,
      minWidth: 4,
      height: '100%',
      ...isSelected && {
        backgroundColor: palette.themePrimary,
      },
    }),
    TreeNodeName: {
      fontSize: 14,
      lineHeight: '20px',
      width: 196,
      paddingRight: 16,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textAlign: 'left',
    },
    HiddenTooltip: {
      display: 'none',
    },
  };
};
